import { createSlice } from '@reduxjs/toolkit'

const beneficiaryCoursesStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: beneficiaryCoursesStatus.LOADING,
    courses: [],
    errorMessage: null,
}

const beneficiaryCoursesSlice = createSlice({
    name: 'beneficiaryCourses',
    initialState,
    reducers: {
        getCoursesRequest: state => {
            state.status = beneficiaryCoursesStatus.LOADING
        },
        getCoursesRequestSuccess: (state, action) => {
            state.courses = action.payload
            state.status = beneficiaryCoursesStatus.SUCCESS
        },
        getCoursesRequestError: (state, action) => {
            state.errorMessage = action.payload
            state.status = beneficiaryCoursesStatus.FAILURE
        },
    },
})

const {
    getCoursesRequest,
    getCoursesRequestSuccess,
    getCoursesRequestError,
} = beneficiaryCoursesSlice.actions

export const beneficiaryCoursesActions = {
    getCoursesRequest,
    getCoursesRequestSuccess,
    getCoursesRequestError,
}

export const beneficiaryCoursesSelectors = {
    isFetching: state =>
        state.beneficiaryCourses.status === beneficiaryCoursesStatus.LOADING,
    hasError: state =>
        state.beneficiaryCourses.status === beneficiaryCoursesStatus.FAILURE,
    errorMessage: state => state.beneficiaryCourses.errorMessage,
    courses: state => state.beneficiaryCourses.courses,
}

const beneficiaryCoursesReducer = beneficiaryCoursesSlice.reducer

export default beneficiaryCoursesReducer
